// 已綁定設備〔更換 Wi-Fi〕（SPEC #provisioning-s4-7-app）：VMS 設備詳細比照 LS Home web——網頁沒有藍牙、也加入不了設備熱點，
// 只在維護區寫一列「請用手機 App 更換」、不能按。條件照抄 app/home-base web/src/features/devices/changeWifi.ts。
import type { VmsDevice } from './devices';

/** 宣告這個能力 = 韌體做了 `kinio_provisioning.open_window`（只有命令的 cluster，同 kinio_ptz）。 */
export const CHANGE_WIFI_CLUSTER = 'kinio_provisioning';

/**
 * 出不出〔更換 Wi-Fi〕：能管理（owner / admin）、不是子 Thing，而且設備宣告了 kinio_provisioning（firmware d4e62c3d 起 12 機種）。
 * 沒宣告的不出（UX-11）：較舊的 Kinio 韌體、v1 / v2 承接、ONVIF、子設備、NVR / Station。
 */
export function changeWifiOffered(
  dev: Pick<VmsDevice, 'aid' | 'parentAid' | 'capabilities' | 'capsDeclared'> & { access?: { can_manage?: boolean } | null },
): boolean {
  if (!dev.access?.can_manage || dev.parentAid || dev.aid.includes(':') || !dev.capsDeclared) return false;
  return dev.capabilities?.includes(CHANGE_WIFI_CLUSTER) ?? false;
}
